import { z } from "zod";
import { acceptedContractEnvelopeSchema, admittedEvidenceBundleSchema, contractCandidateSchema, determinationSchema, environmentBindingSchema, evidenceSubmissionSchema, machineReadableVerdictReceiptSchema, protocolIdSchema, protocolVersionIdSchema, protocolVersionSchema, sha256DigestSchema, workAttemptSchema, } from "../protocol/client.js";
import { universalConsoleOverviewSchema, universalReceiptDetailSchema, universalTrustMaterialSchema, universalWorkDetailSchema, } from "./console-model.js";
import { railAdapterKindSchema, railVerificationSignalSchema } from "./adapters.js";
import { projectUniversalCompletionOverview } from "./console.js";
export { projectUniversalCompletionOverview, railAdapterKindSchema, railVerificationSignalSchema, universalConsoleOverviewSchema, universalReceiptDetailSchema, universalTrustMaterialSchema, universalWorkDetailSchema, };
export const universalVerifyCommandSchema = z
    .object({
    protocolVersion: protocolVersionSchema,
    idempotencyKey: protocolIdSchema,
    contract: z.union([acceptedContractEnvelopeSchema, contractCandidateSchema]),
    evidence: evidenceSubmissionSchema,
    environmentBinding: environmentBindingSchema,
    attempt: workAttemptSchema.optional(),
    policy: z
        .object({
        ref: protocolIdSchema,
        version: protocolVersionIdSchema,
        digest: sha256DigestSchema,
    })
        .strict(),
    replay: z
        .object({
        status: z.enum(["REPLAYED", "REPLAYABLE", "BLOCKED", "NOT_AVAILABLE"]),
        environmentDigest: sha256DigestSchema,
        commands: z.array(z.string().trim().min(1)).optional(),
        replayedAt: z.string().datetime({ offset: true }).nullable().optional(),
        reasonCodes: z.array(protocolIdSchema).optional(),
    })
        .strict(),
    supersedesReceiptId: protocolIdSchema.nullable().optional(),
})
    .strict();
export const universalVerifyResponseSchema = z
    .object({
    protocolVersion: protocolVersionSchema,
    assurance: z.enum(["PROSPECTIVE", "RETROSPECTIVE"]),
    verdict: z.enum(["PASS", "FAIL", "INCOMPLETE", "PARTIAL"]),
    evidence: admittedEvidenceBundleSchema,
    determinations: z.array(determinationSchema),
    receipt: machineReadableVerdictReceiptSchema,
    receiptBytes: z.string().min(1),
})
    .strict();
